import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { CountryDirectionType } from './hooks.type';

import { getInboundCountry, getDispatchCountry } from '../selectors';
import { getCountryProvider } from '../../../config/providers';

export const useProvider = (direction: CountryDirectionType) => {
  const country = useSelector(direction === 'sender' ? getDispatchCountry : getInboundCountry);

  return useMemo(() => getCountryProvider(country), [country]);
};

export const useSenderProvider = () => {
  const { provider } = useSelector(getDispatchCountry);

  return provider;
};
